import React, { Component } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import SecureRoute from "../helpers/secure-route";
import ScrollToTop from "../helpers/scroll-to-top";

import {
    reauthenticateFromStoredToken,
} from "../../ducks/auth";
import { getVideosList } from "../../ducks/videos";

import VideosList from "../videos-list";
import Video from "../video";
import Login from "../login";

import "./root.css";

class Root extends Component {
    componentDidMount() {
        const { reauthenticateFromStoredToken, getVideosList } = this.props;
        reauthenticateFromStoredToken();
        // TODO: this will need to be a bit smarter. See videos duck.
        getVideosList();
    }

    render() {
        return (
            <Router>
                <ScrollToTop>
                    <Switch>
                        <Route path="/login" exact component={Login} />
                        <Route path="/login/:redirectTo" component={Login} />
                        <Route path="/video/:videoId" exact component={SecureRoute(Video)} />
                        <Route path="/" exact component={SecureRoute(VideosList)} />
                    </Switch>
                </ScrollToTop>
            </Router>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
    };
};
const mapDispatchToProps = {
    reauthenticateFromStoredToken,
    getVideosList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js